import _ from "lodash";
import Grid from "@mui/material/Grid";
import React, { useState, useEffect } from "react";
import { Box } from "@mui/system";
import { Typography } from "@mui/material";
import { unicodeToString } from "../../../../Js/Common";

const pathToParentMenu = ["root"];

const WwSmallChit = (props) => {
  let [alignClass, setAlignClass] = useState('');
  let [classnames, setClassnames] = useState("SmallChit");

  useEffect(() => {
    // if (props.data && props.data.class) {
    //   setClassnames(`${props.data.class} SmallChit`);
    // }
  }, [props.data]);

  useEffect(() => {
    console.log("initHide",props.initHide)
  }, [props.initHide]);

  return (
    <Grid container>
      <Grid item xs={12}>
        <Box
          sx={{
            p: 1,
            pl: 0,
            my: 1,
            mt: 0.5,
            mr: 1,
            border: 1,
            borderColor: '#d3d3d3',
            backgroundColor: '#F5F7FF',
            borderRadius: 5,
            width: 'inherit',
          }}
          id="hhh"
        >
          <Typography sx={{ color: "primary.main", pl: 1, fontWeight: 500, wordSpacing: '2px'}}>
            <div
              className={classnames}
              id={props.data.myId.self}
              dangerouslySetInnerHTML={{
                __html: unicodeToString(props.data.source),
              }}
              style={{
                display: props.initHide && props.initHide.indexOf(props.data.myId.self) > -1 ? 'none' : 'inline-block', width: 'inherit'
              }}
            ></div>
          </Typography>
        </Box>
      </Grid>
    </Grid>
  );
};

export default WwSmallChit;
